import makeAction from "./../../libs/actions";

export const fetchTracksAction = makeAction("tracks/FETCH_TRACKS");
export const fetchTrackBySlugAction = makeAction("tracks/FETCH_TRACK_BY_SLUG");
